import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        component: () => import('@/views/_layout.vue'),
        meta: {
            // requiresAuth: true,
            isAdmin: true
        },
        children: [
            {
                path: '/',
                component: () => import('@/views/home.vue'),
                name: 'Home'
            },
            {
                path: '/carts',
                name: 'Orders',
                component: () => import('@/views/carts.vue')
            },
            {
                path: '/carts/:id',
                component: () => import('@/views/cart.vue'),
                name: 'Edit Cart',
                meta: {
                    title: 'Edit Order',
                    noCache: true,
                    hidden: true
                }
            },
            {
                path: '/cartgroups',
                component: () => import('@/views/cartGroups.vue'),
                name: 'Order Groups',
                meta: { title: 'Cart Groups', icon: 'documentation', noCache: true }
            },
            {
                path: '/reprintgroups',
                name: 'Reprint Groups',
                component: () => import('@/views/reprintGroups.vue')
            },
            {
                path: '/reprintgroups/:id',
                name: 'Reprints',
                component: () => import('@/views/reprintsView.vue')
            },
            {
                path: '/amazon',
                name: 'Amazon Orders',
                component: () => import('@/views/amazonOrders.vue')
            },
            {
                path: '/zazzle',
                name: 'Zazzle Orders',
                component: () => import('@/views/zazzleOrders.vue')
            },
            {
                path: '/ppi',
                name: 'PPI Orders',
                component: () => import('@/views/ppiOrders.vue')
            },
            {
                path: '/ppiproducts',
                name: 'PPI Products',
                component: () => import('@/views/ppiProducts.vue')
            },
            { 
                path: '/ppiproducts/:id',
                name: 'PPI Product',
                component: () => import('@/views/ppiProduct.vue')
            },
            {
                path: '/ppipayments',
                name: 'PPI Payments',
                component: () => import('@/views/ppiPayments.vue')
            },
            {
                path: '/arts',
                name: 'Art List',
                component: () => import('@/views/arts.vue')
            },
            {
                path: '/arts/:id',
                name: 'Edit Art',
                component: () => import('@/views/art.vue')
            },
            {
                path: '/artworkprogress',
                name: 'Artwork Progress',
                component: () => import('@/views/artworkProgress.vue')
            },
            {
                path: '/reports',
                name: 'Reports',
                component: () => import('@/views/reports.vue')
            },
            {
                path: '/fulfillment',
                name: 'Fulfillment',
                component: () => import('@/views/fulfillment.vue')
            },
            {
                path: '/workflow',
                name: 'Artwork Workflows',
                component: () => import('@/views/workflow.vue')
            },
            {
                path: '/svgcanvases',
                component: () => import('@/views/svgCanvases.vue'),
                name: 'MyMoji',
                meta: { title: 'Canvases', icon: 'documentation', noCache: true }
            },
            {
                path: '/svgcanvases/:id',
                component: () => import('@/views/svgCanvas.vue'),
                name: 'Edit Canvas',
                meta: {
                    title: 'Edit Canvas',
                    noCache: true,
                    hidden: true
                }
            },
            {
                path: '/cartshipments',
                name: 'Shipping Labels',
                component: () => import('@/views/cartShipments.vue')
            },
            {
                path: '/accounts',
                name: 'Customer Accounts',
                component: () => import('@/views/accounts.vue')
            },
            {
                path: '/accounts/:siteId/:emailAddress',
                name: 'Customer Account',
                component: () => import('@/views/account.vue')
            },
            {
                path: '/fundraisers',
                name: 'Fundraisers',
                component: () => import('@/views/fundraisers.vue')
            },
            {
                path: '/fundraisers/:id',
                name: 'Fundraiser',
                component: () => import('@/views/fundraiser.vue')
            },
            {
                path: '/promocodes',
                name: 'Promo Codes',
                component: () => import('@/views/promoCodes.vue')
            },
            {
                path: '/promocodes/:id',
                name: 'Promo Code',
                component: () => import('@/views/promoCode.vue')
            },
            {
                path: '/svgresources',
                name: 'SVG Resources',
                component: () => import('@/views/svgResources.vue')
            },
            {
                path: '/svgresources/:container/:filename',
                name: 'SVG Resource',
                component: () => import('@/views/svgResource.vue')
            },
            {
                path: '/giftcards',
                name: 'Gift Cards',
                component: () => import('@/views/giftCards.vue')
            },
            {
                path: '/production',
                name: 'Production',
                component: () => import('@/views/production.vue')
            },
            {
                path: '/catalog',
                name: 'Catalog',
                component: () => import('@/views/catalog.vue')
            },
            {
                path: '/catalog/product/:id',
                name: 'Catalog Product',
                component: () => import('@/views/catalogProduct.vue')
            },
            {
                path: '/catalog/design/:id',
                name: 'Catalog Design',
                component: () => import('@/views/catalogDesign.vue')
            },
            {
                path: '/catalog/package/:id',
                name: 'Catalog Package',
                component: () => import('@/views/catalogPackage.vue')
            },
            {
                path: '/catalog/productcategory/:id',
                name: 'Catalog Product Category',
                component: () => import('@/views/catalogProductCategory.vue')
            },
            {
                path: '/catalog/designcategory/:id',
                name: 'Catalog Design Category',
                component: () => import('@/views/catalogDesignCategory.vue')
            },
            {
                path: '/catalog/mixedsheet/:id',
                name: 'Catalog Mixed Sheet',
                component: () => import('@/views/catalogMixedSheet.vue')
            },
            {
                path: '/amazonlistings',
                name: 'Amazon Listings',
                component: () => import('@/views/amazonListings.vue')
            },
            {
                path: '/amazonlistings/:id',
                name: 'Amazon Listing',
                component: () => import('@/views/amazonListing.vue')
            },
            {
                path: '/wayfairlistings',
                name: 'Wayfair Listings',
                component: () => import('@/views/wayfairListings.vue')
            },
            //{
            //    path: '/wayfairlistings/:id',
            //    name: 'Wayfair Listing',
            //    component: () => import('@/views/wayfairListing.vue')
            //},
            {
                path: '/founditems',
                name: 'Found Items',
                component: () => import('@/views/foundItems.vue')
            },
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login.vue'),
        meta: { hidden: true }
    },
    {
        path: '/passwordreset',
        name: 'PasswordReset',
        component: () => import('@/views/passwordReset.vue'),
        meta: { hidden: true }
    },
    {
        path: '/artworkProcess/:id',
        name: 'artworkprocess',
        component: () => import('@/views/artworkProcessMonitor.vue')
    },
    {
        path: '/businessproducts',
        name: 'businessproducts',
        component: () => import('@/views/businessProducts.vue')
    },
    // {
    //     path: '/about',
    //     name: 'About',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }
]

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
